{
  "app": {
    "name": "Delta WorkForce",
    "tagline": "斯坦福设施部劳动力管理平台"
  },
  "nav": {
    "home": "首页",
    "workOrders": "工单",
    "scan": "扫码",
    "timecards": "工时卡",
    "notifications": "通知",
    "whatsNew": "最新动态",
    "approvals": "审批",
    "team": "团队",
    "assets": "资产",
    "locations": "位置",
    "map": "地图",
    "crew": "员工",
    "schedule": "排班",
    "parts": "零件",
    "tools": "工具",
    "vendors": "供应商",
    "leaderboard": "排行榜",
    "kudos": "表扬",
    "messages": "消息",
    "feedback": "反馈",
    "insights": "洞察",
    "reports": "报告",
    "communications": "通讯草稿",
    "howto": "操作指南草稿",
    "forms": "表单",
    "admin": "管理",
    "settings": "设置",
    "integrations": "集成",
    "more": "更多",
    "invoiceQueue": "发票队列",
    "dispatch": "派工",
    "fleetCalendar": "车队日历",
    "vehicles": "车辆",
    "fleetDashboards": "车队仪表盘",
    "approvalsQueue": "审批队列",
    "serviceWindows": "服务时段",
    "fleetAdmin": "车队管理",
    "lifecycle": "生命周期",
    "transfers": "调拨",
    "myVehicles": "我的车辆",
    "myApprovals": "待审批",
    "approvalHistory": "历史记录",
    "impersonate": "身份模拟",
    "dashboardEditor": "首页编辑器",
    "automations": "自动化任务",
    "pmSchedules": "预防性维护计划",
    "workforceCalendar": "排班日历",
    "help": "帮助中心"
  },
  "nav_desc": {
    "home": "每日概览——接下来要做什么，一目了然。",
    "workOrders": "进行中的工单、状态、隐患与历史记录。",
    "timecards": "按工单或常规时间登记工时。",
    "approvals": "审批等待你处理的请求。",
    "team": "人员名单、任务分配与在岗状态。",
    "insights": "工单、工时与团队的趋势分析。",
    "reports": "保存的报表与对外导出。",
    "communications": "面向租户与干系人的 AI 辅助通讯草稿。",
    "howto": "记录并完善标准作业程序。",
    "forms": "按工种分类的巡检与合规表单。",
    "assets": "设备查询、手册与维修历史。",
    "locations": "楼宇、房间与现场信息。",
    "map": "带任务与资产的园区地图。",
    "crew": "班组名册、证书与联系方式。",
    "schedule": "排班日历与任务分配。",
    "parts": "零件目录、库存与补货。",
    "tools": "工具借用、校准与库存。",
    "vendors": "外部承包商、合同与联系人。",
    "leaderboard": "班组之间的良性竞赛。",
    "kudos": "表彰同事的出色工作。",
    "messages": "频道与私信对话。",
    "whatsNew": "最新平台更新与发布说明。",
    "settings": "个人资料、通知与偏好设置。",
    "integrations": "Maximo、SSO 以及其他系统连接。",
    "admin": "租户设置、用户与审计日志。",
    "more": "你可用的所有应用。",
    "invoiceQueue": "供应商发票三方匹配审核。",
    "dispatch": "将工单分配给你的技术员。",
    "fleetCalendar": "车辆预约与供应商调度。",
    "vehicles": "车队车辆、召回与维修历史。",
    "fleetDashboards": "外出维修、逾期工单、供应商绩效。",
    "approvalsQueue": "客户审批跟踪与升级。",
    "serviceWindows": "供应商服务时段、时隙报价与操作员预订。",
    "fleetAdmin": "保险、注册、租赁、调拨、处置。",
    "lifecycle": "车辆生命周期时间线、TCO 与子记录。",
    "transfers": "部门间车辆调拨与审批。",
    "myVehicles": "你部门的车辆与服务状态。",
    "myApprovals": "等待你审批的维修报价。",
    "approvalHistory": "历史审批决定与维修记录。",
    "impersonate": "以其他用户身份查看应用（只读）。",
    "dashboardEditor": "按角色配置首页组件。",
    "automations": "定时任务与按需自动化。",
    "pmSchedules": "定期预防性维护工单计划。",
    "workforceCalendar": "排班、请假与加班管理。",
    "help": "交互式流程指南与角色说明。"
  },
  "actions": {
    "save": "保存",
    "saveDraft": "保存草稿",
    "cancel": "取消",
    "submit": "提交",
    "delete": "删除",
    "edit": "编辑",
    "create": "创建",
    "add": "添加",
    "remove": "移除",
    "assign": "指派",
    "unassign": "取消指派",
    "approve": "批准",
    "reject": "拒绝",
    "close": "关闭",
    "back": "返回",
    "next": "下一步",
    "done": "完成",
    "search": "搜索",
    "filter": "筛选",
    "clear": "清除",
    "upload": "上传",
    "takePhoto": "拍照",
    "translate": "翻译",
    "showOriginal": "显示原文",
    "viewAll": "查看全部",
    "viewMore": "查看更多",
    "loading": "加载中…",
    "retry": "重试",
    "signIn": "登录",
    "signOut": "退出"
  },
  "status": {
    "open": "待处理",
    "assigned": "已指派",
    "inProgress": "进行中",
    "onHold": "暂停",
    "completed": "已完成",
    "closed": "已关闭",
    "cancelled": "已取消",
    "available": "在岗",
    "onLeave": "请假",
    "offDuty": "下班"
  },
  "priority": {
    "emergency": "紧急情况",
    "urgent": "紧急",
    "high": "高",
    "medium": "中",
    "low": "低"
  },
  "fields": {
    "description": "描述",
    "location": "位置",
    "trade": "工种",
    "priority": "优先级",
    "assignedTo": "指派给",
    "dueDate": "截止日期",
    "estimatedHours": "预估工时",
    "status": "状态",
    "name": "姓名",
    "email": "邮箱",
    "phone": "电话",
    "role": "角色",
    "notes": "备注"
  },
  "validation": {
    "required": "必填",
    "mustBeNumber": "必须是数字",
    "minLength": "过短",
    "maxLength": "过长",
    "invalidEmail": "邮箱无效"
  },
  "notify": {
    "critical": "严重",
    "important": "重要",
    "info": "信息"
  },
  "common": {
    "yes": "是",
    "no": "否",
    "none": "无",
    "all": "全部",
    "any": "任意",
    "unknown": "未知",
    "notAvailable": "不可用"
  },
  "settings": {
    "language": "语言",
    "preferences": "偏好设置",
    "profile": "个人资料",
    "theme": "主题",
    "textSize": "文字大小",
    "textSizeHint": "调整应用中所有文字和界面元素的大小",
    "simplified": "简化模式（更大的触控区域和文字）",
    "themeDark": "默认",
    "themeDarkDesc": "工业深色 — 默认",
    "themeLight": "浅色",
    "themeLightDesc": "干净的白色界面",
    "themeHighContrast": "高对比度",
    "themeHighContrastDesc": "OLED 纯黑",
    "themeSunlight": "户外",
    "themeSunlightDesc": "户外最大对比度",
    "themeTechConnect": "TechConnect",
    "themeTechConnectDesc": "斯坦福红金主题"
  },
  "translate": {
    "translateButton": "翻译",
    "translating": "翻译中…",
    "translatedFrom": "译自 {{lang}}",
    "failed": "翻译失败"
  },
  "pages": {
    "helpCenter": "帮助中心",
    "helpCenterDesc": "了解关键工作流的运作方式——谁做什么、按什么顺序、在哪里进行。",
    "allRoles": "所有角色",
    "searchFlows": "搜索流程、角色或操作...",
    "noFlowsFound": "未找到流程，请尝试其他搜索。",
    "flowNotFound": "未找到流程。",
    "backToHelp": "返回帮助中心",
    "stepsInDetail": "详细步骤",
    "workOrders": "工单",
    "newWorkOrder": "新建工单",
    "searchWO": "按描述、位置或编号搜索…",
    "insights": "洞察",
    "insightsDesc": "用自然语言提问、查看仪表盘、发现异常。",
    "askQuestion": "提问",
    "askPlaceholder": "例如：上个月有多少HVAC工单？",
    "ask": "提问",
    "anomalies": "异常",
    "compliance": "合规评分卡",
    "vendors": "供应商",
    "forms": "表单",
    "formBuilder": "表单设计器",
    "formDetails": "表单详情",
    "addField": "添加字段",
    "livePreview": "实时预览",
    "exitPreview": "退出预览",
    "preview": "预览",
    "tools": "工具",
    "leaderboard": "排行榜",
    "kudos": "表扬",
    "chooseTechmate": "选择一位同事…",
    "reports": "报告",
    "howToDrafts": "操作指南草稿",
    "commsDrafter": "通讯草稿",
    "crew": "员工",
    "locations": "位置",
    "partsCatalog": "零件目录",
    "assets": "资产",
    "messages": "消息",
    "allChannels": "所有频道",
    "feedback": "反馈",
    "fleetVehicles": "车队车辆",
    "fleetCalendar": "车队日历",
    "approvalsQueue": "审批队列",
    "noApprovals": "审批队列为空",
    "pendingApprovals": "待审批",
    "noPendingApprovals": "没有待审批项",
    "approvalHistory": "审批历史",
    "noHistory": "暂无记录",
    "myVehicles": "我的车辆",
    "noVehicles": "未分配车辆",
    "schedule": "排班",
    "notifications": "通知",
    "markAllRead": "全部标为已读",
    "adminConsole": "管理控制台",
    "integrations": "集成",
    "invoiceQueue": "发票审核队列",
    "dashboardEditor": "首页编辑器",
    "savedChanges": "已保存",
    "saveChanges": "保存更改",
    "map": "地图",
    "locateMe": "定位我",
    "includeClosed": "包含已关闭",
    "searchPins": "搜索标记点…",
    "navigate": "导航"
  },
  "filters": {
    "allTrades": "全部工种",
    "allStatuses": "全部状态",
    "allTypes": "全部类型",
    "allRoles": "全部角色",
    "allCategories": "全部分类",
    "allKinds": "全部种类",
    "allFuelTypes": "全部燃料类型",
    "allMethods": "全部方法",
    "allEntityTypes": "全部实体类型"
  },
  "trades": {
    "hvac": "暖通空调",
    "plumbing": "管道",
    "electrical": "电气",
    "general": "综合"
  },
  "fleet": {
    "ice": "燃油车",
    "ev": "纯电动",
    "phev": "插电混动",
    "hybrid": "混动",
    "available": "可用",
    "inService": "使用中",
    "outForService": "外出维修",
    "scheduled": "已预约",
    "staged": "已准备",
    "pickedUp": "已取车",
    "returned": "已归还",
    "canceled": "已取消",
    "escalated": "已升级",
    "aging": "超时",
    "pending": "待处理",
    "proposed": "已提议",
    "cedingApproved": "转出方已批准",
    "receivingApproved": "接收方已批准",
    "executed": "已执行"
  },
  "calendar": {
    "leave": "请假",
    "overtime": "加班",
    "leaveRequest": "请假申请",
    "overtimeRequest": "加班申请",
    "pendingRequests": "待处理申请",
    "workOrders": "工单",
    "hours": "小时",
    "reason": "原因",
    "tech": "技术员",
    "hrs": "时",
    "prev": "上一页",
    "next": "下一页"
  },
  "widgets": {
    "myWork": "我的工单",
    "timecards": "工时卡",
    "thisWeek": "本周",
    "fleetStatus": "车队状态",
    "pendingApprovals": "待审批",
    "teamAvailability": "团队可用性",
    "recentMessages": "最近消息",
    "quickLinks": "快捷链接"
  },
  "ai": {
    "formBuilder": "AI 表单设计器",
    "describeForm": "描述你需要的表单",
    "generating": "生成中…",
    "generateForm": "生成表单"
  },
  "groups": {
    "Work": "工作",
    "People": "人员",
    "Assets": "资产",
    "Fleet": "车队",
    "Insights": "洞察",
    "Admin": "管理",
    "Preferences": "偏好"
  },
  "groups_desc": {
    "Work": "日常任务、工时记录和审批。",
    "People": "团队、员工、排班和供应商。",
    "Assets": "设备、位置、零件和工具。",
    "Fleet": "车辆物流、预约和生命周期。",
    "Insights": "分析、报告和表彰。",
    "Admin": "预防性维护计划、自动化、表单和系统。",
    "Preferences": "帮助、版本说明和个人设置。"
  },
  "more": {
    "title": "更多",
    "subtitle": "点击分组查看应用。"
  },
  "home": {
    "goodMorning": "早上好",
    "goodAfternoon": "下午好",
    "goodEvening": "晚上好",
    "loading": "加载仪表盘…"
  },
  "roles": {
    "technician": "技术员",
    "supervisor": "主管",
    "admin": "管理员",
    "sysadmin": "系统管理员",
    "vendor_admin": "供应商管理员",
    "vendor_supervisor": "供应商主管",
    "vendor_tech": "供应商技术员",
    "customer_operator": "客户 / 操作员"
  },
  "login": {
    "chooseOrg": "选择一个组织开始探索",
    "heritage": "LBRE 在 TechConnect 中完善的每个业务流程都得以延续——以更快的速度、更高的清晰度、为斯坦福设施的未来而重建。"
  },
  "sw": {
    "pageTitle": "服务时段",
    "headerStats": "{{published}} 已发布 · {{drafts}} 草稿（{{pmDrafts}} 来自 PM）",
    "filterAll": "所有状态",
    "statusDraft": "草稿",
    "statusPublished": "已发布",
    "statusCanceled": "已取消",
    "newWindow": "新建时段",
    "loading": "加载中…",
    "loadingTimes": "正在加载可用时间…",
    "emptyTitle": "暂无服务时段",
    "emptyDesc": "手动创建一个，或在系统设置中启用 PM 自动生成计划。",
    "today": "今天",
    "capacityLabel": "容量 {{n}}",
    "cohortLabel": "车型：{{type}}",
    "vendorLabel": "供应商 {{id}}",
    "publishTitle": "发布",
    "cancelWindowTitle": "取消时段",
    "pmDraftsTitle": "PM 草稿（{{count}}）",
    "pmDraftsEmpty": "队列中无 PM 草稿。请在系统设置中启用调度器以自动生成。",
    "publishAllDrafts": "发布全部 {{count}} 个草稿",
    "thisHorizon": "本期总览",
    "totalWindows": "时段总数",
    "statsPublished": "已发布",
    "statsDrafts": "草稿",
    "composerTitle": "新建服务时段",
    "fieldStart": "开始",
    "fieldEnd": "结束",
    "fieldLocation": "地点",
    "locationPlaceholder": "车库2号湾 · LBRE",
    "fieldVendorId": "供应商 ID",
    "vendorIdPlaceholder": "grainger-uuid",
    "fieldCapacity": "容量",
    "fieldCohort": "车辆群组（类型标签）",
    "cohortPlaceholder": "transit-van · cart · bolt-ev · …",
    "publishImmediately": "立即发布（否则保存为草稿）",
    "cancel": "取消",
    "saving": "保存中…",
    "publish": "发布",
    "saveDraft": "保存草稿",
    "errInvalidTimes": "请输入有效的开始和结束时间。",
    "errEndBeforeStart": "结束时间必须晚于开始时间。",
    "errStartPast": "时段必须在未来开始。",
    "errLocationRequired": "地点不能为空。",
    "errVendorRequired": "供应商 ID 不能为空。",
    "errCapacityRange": "容量必须在 1 到 50 之间。",
    "errCreateFailed": "创建时段失败",
    "vendorPageTitle": "确认服务时段",
    "statsPending": "待处理报价",
    "statsConfirmed": "已确认",
    "statsDeclined": "已拒绝",
    "statsTotal": "本期总计",
    "vendorEmptyTitle": "暂无服务时段报价",
    "vendorEmptyDesc": "当车队管理员发布分配给您组织的时段后，将在此处显示。",
    "mixedCohort": "混合车型",
    "locationColon": "地点：",
    "partialConfirmed": "部分确认 · {{confirmed}} / {{total}} 已确认",
    "statusDeclined": "已拒绝",
    "statusAccepted": "已接受",
    "confirmedCapacity": "确认容量：",
    "save": "保存",
    "accept": "接受",
    "partial": "部分",
    "decline": "拒绝",
    "acceptTitle": "接受完整时段",
    "partialTitle": "部分接受",
    "declineTitle": "拒绝",
    "operatorPageTitle": "选择服务时间",
    "forYourVehicle": "为您的车辆",
    "selectVehicle": "选择车辆…",
    "emptyVehicleTitle": "请选择车辆",
    "emptyVehicleDesc": "选择一辆车以查看可用的服务时间。",
    "noWindowsTitle": "暂无可用时段",
    "noWindowsDesc": "车队管理员和供应商尚未为此车辆确认任何时间。",
    "availableSlots_one": "{{count}} 个可用时段",
    "availableSlots_other": "{{count}} 个可用时段",
    "next30Days": "未来 30 天",
    "booking": "预订中…",
    "selectWindowAbove": "请在上方选择时段",
    "bookSlot": "预订 {{date}} · {{time}}",
    "publicBrand": "Delta WorkForce · 车队",
    "forYour": "为您的",
    "bookedSuccess": "✓ 已预订！您的服务时段已确认，暂存前您将收到提醒。",
    "noWindowsPublic": "暂无可用时段，请等待车队管理员发布新时段后再试。",
    "confirmBooking": "确认预订",
    "publicFooter": "此链接绑定到您的车辆，转发给他人不会记录预订。",
    "errMissingToken": "缺少令牌",
    "errPickLinkInvalid": "选择链接无效",
    "errBookingFailed": "预订失败"
  }
}
